import { apiConf, sendRequest, ppAxios, ppAxiosInstance } from '../config'

/**
 * 结算报表
 */
export const selectSettlementData = param => {
	return sendRequest(apiConf.settlementApi.selectSettlementData, param)
}
/**
 * 获取审核通过的网站列表
 */
export const getStoreList = param => {
	return sendRequest(apiConf.settlementApi.storeList, param)
}
/**
 * 导出excel表格
 */
export const exportExcel = (param, options) => {
	return ppAxios(apiConf.settlementApi.exportExcel, param, options)
}

/**
 * 月发票查询
 */
export const invoiceList = (params) => {
	return sendRequest(['GET', '/merchant/acquirer/statement/invoiceList'], params)
}

/**
 * 月发票下载
 */
export const billInvoiceDownload = (params) => {
	return ppAxios(['GET', '/merchant/acquirer/statement/downLoad'], params, {
		responseType: 'blob'
	})
}

/**
 * 生成对账单
 */
export const billInvoiceCreate = (params) => {
	return ppAxios(['POST', '/merchant/acquirer/statement/create'], params)
}

/**
 * 对账单查询
 */
export const billList = (params) => {
	return sendRequest(['GET', '/merchant/acquirer/statement/billList'], params)
}

/**
 * 报表管理 - 交易明细
 */
export const statementList = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/tradeNew/statementList'], params, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}

/**
 * 网站列表 - 根据groupid查询
 */
export const storeListByGroup = (params) => {
	return sendRequest(['GET', '/merchant/acquirer/store/getStoresByGroupId'], params)
}

export const apiGetStoreList = (params) => {
	return sendRequest(apiConf.settlementApi.storeList, params)
}
/**
 * 网站列表 - 获取支付方式列表
 */
export const fetchCardTypeOptions = () => {
	return sendRequest(['GET', '/merchant/acquirer/tradeNew/getPayMethod'])
}

/**
 * 对账单设置 - 是否配置可见
 */
export const queryCustomBillSwitch = () => {
	return sendRequest(['GET', '/merchant/acquirer/customBill/queryCustomBillSwitch'])
}

/**
 * 对账单设置 - 获取账单配置数据
 */
export const queryBillConfig = () => {
	return sendRequest(['POST', '/merchant/acquirer/customBill/queryBillConfig'])
}

/**
 * 对账单设置 - 保存账单配置数据
 */
export const saveBillConfig = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/customBill/saveBillConfig'], params)
}

/**
 * 对账单字段设置 - 获取账单模板
 */
export const queryBillTemplate = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/customBill/queryBillTemplate'], params)
}

/**
 * 对账单字段设置 - 获取全自定义账单模板字段
 */
export const queryCustomBillTemplate = () => {
	return sendRequest(['POST', '/merchant/acquirer/customBill/queryCustomBillTemplate'])
}

/**
 * 对账单字段设置 - 获取全自定义账单模板
 */
export const queryTemplateNameList = () => {
	return sendRequest(['POST', '/merchant/acquirer/customBill/queryTemplateNameList'])
}

/**
 * 对账单字段设置 - 保存账单模板
 */
export const saveBillTemplate = (params) => {
	return ppAxiosInstance.post('/merchant/acquirer/customBill/saveBillTemplate', params, {
		headers: {
			accessToken: window.sessionStorage.getItem('accessToken')
		}
	})
}

/**
 * 对账单字段设置 - 删除全自定义账单模板
 */
export const removeCustomBillTemplate = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/customBill/removeCustomBillTemplate'], params)
}
